import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, shareReplay, tap } from 'rxjs';
import { User } from '../models/user';
import { environment } from '../../environments/environment';
import { GoogleTagManagerService } from './google-tag-manager.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private user$: Observable<User> | null = null;
  private pushedToGTM = false;

  private http = inject(HttpClient);
  private gtmService = inject(GoogleTagManagerService);

  getUserInfo() {
    if (!this.user$) {
      this.user$ = this.http.get<User>(`${environment.apiUrl}/users/me`).pipe(
        tap(({ type }) => {
          if (!this.pushedToGTM) {
            this.gtmService.pushEvent({
              event: 'client_type',
              auth: { authType: type === 'Internal' ? 'Intern' : 'Ekstern' }
            });
            this.pushedToGTM = true;
          }
        }),
        shareReplay(1)
      );
    }
    return this.user$;
  }

  isUserAdmin() {
    return this.getUserInfo().pipe(map(({ permissions }) => permissions.includes('Users.Admin')));
  }
}
